export enum MiniCardLayout {
  HORIZONTAL = 'horizontal',
  VERTICAL_STACKED = 'verticalStacked',
  HORIZONTAL_WITH_BUTTON = 'horizontalWithButton',
}

export enum BasicCardLayout {
  TWO_COLUMN = 'twoColumn',
  THREE_COLUMN = 'threeColumn',
}
